export default __webpack_public_path__ + "static/media/Foto18.4bb385fe.png";